<app-page-heading [key]="'user-dashboard.blueyonder-user.form.page-title.creation'" [subheadingIcon]="'fa fa-user-plus'"></app-page-heading>

<section class="container">
    <div class="row">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-4">
                    <button type="button" class="btn btn-primary btn-outline btn-lg pull-left"
                            (click)="location.back()">
                        <span class="fa fa-arrow-left"></span>
                    </button>
                </div>
            </div>

            <br>

            <div class="ibox float-e-margins">
                <div class="ibox-content">
                    <form #blueyonderUserForm="ngForm" (submit)="processForm()" novalidate class="row">
                        <fieldset class="col-xs-12">

                            <div class="form-group">
                                <label class="control-label" for="byUser-userCode"
                                       [i18n]="'user-dashboard.blueyonder-user.form.userCode.label'"></label>
                                <input type="text" class="form-control input-lg" id="byUser-userCode" name="byUser-userCode" required
                                       [maxLength]="maxLengthUserCode" [pattern]="'[A-Za-z1-9]+'"
                                       (input)="userCodeChanged()"
                                       [(ngModel)]="blueyonderUser.userCode" #userCode="ngModel">
                                <label class="error" *ngIf="userCode.dirty && userCode.errors?.required"
                                       [i18n]="'validation.required'"></label>
                                <label class="error" *ngIf="userCode.dirty && userCode.errors?.userAlreadyExist"
                                       [i18n]="'user-dashboard.blueyonder-user.form.userCode.userExist'"></label>
                                <label class="error" *ngIf="userCode.dirty && userCode.errors?.pattern"
                                       [i18n]="'user-dashboard.blueyonder-user.form.userCode.pattern'"></label>
                                <small class="help-block m-b-none"
                                       [i18n]="[{target: 'innerHTML', key: 'user-dashboard.blueyonder-user.form.userCode.help', params: { maxLengthUserCode: maxLengthUserCode }}]"></small>
                            </div>

                            <div class="form-group">
                                <label class="control-label" for="byUser-userName"
                                       [i18n]="'user-dashboard.blueyonder-user.form.userName.label'"></label>
                                <input type="text" class="form-control input-lg" name="byUser-userName" id="byUser-userName" required
                                       [(ngModel)]="blueyonderUser.userName" [maxLength]="maxLengthUserName">
                                <small class="help-block m-b-none"
                                       [i18n]="[{target: 'innerHTML', key: 'user-dashboard.blueyonder-user.form.userName.help', params: {maxLengthUserName: maxLengthUserName}}]"></small>
                            </div>

                            <div class="form-group">
                                <label class="control-label" for="byUser-userGroup"
                                       [i18n]="'user-dashboard.blueyonder-user.form.userGroup.label'"></label>
                                <ng-select class="input-lg" name="byUser-userGroup" id="byUser-userGroup" required
                                           [(ngModel)]="blueyonderUser.userGroup"
                                           [items]="logisticGroups"
                                           [bindValue]="'code'"
                                           [bindLabel]="'name'">
                                </ng-select>
                            </div>

                            <div class="form-group">
                                <label class="control-label" for="byUser-languageCode"
                                       [i18n]="'user-dashboard.blueyonder-user.form.languageCode.label'"></label>
                                <span class="info-icon" [tabIndex]="2" (focusout)="toggleTooltip()" (focusin)="toggleTooltip()">
                                    <i class="fa fa-info-circle m-r"></i>
                                    <span class="tooltip-helper" *ngIf="showTooltip"
                                          [i18n]="'user-dashboard.blueyonder-user.form.languageCode.tooltip'"></span>
                                </span>
                                <input type="text" class="form-control input-lg" name="byUser-languageCode" id="byUser-languageCode" disabled
                                       required
                                       [(ngModel)]="blueyonderUser.languageCode">
                            </div>

                            <div class="form-group">
                                <label class="control-label" for="byUser-countryCode"
                                       [i18n]="'user-dashboard.blueyonder-user.form.countryCode.label'"></label>
                                <ng-select class="input-lg" name="byUser-countryCode" id="byUser-countryCode" required
                                           [(ngModel)]="blueyonderUser.countryCode"
                                           [items]="countries"
                                           [bindValue]="'countryId'"
                                           [bindLabel]="'countryName'">
                                </ng-select>
                            </div>

                            <div class="alert-wrapper">
                                <div class="alert alert-info alert-sm">
                                    <i class="fa fa-info-circle m-r"></i>
                                    <div>
                                        <span [i18n]="'user-dashboard.blueyonder-user.form.help.line1'"></span><br>
                                        <span
                                            [i18n]="'user-dashboard.blueyonder-user.form.help.line2'"></span>&nbsp;{{blueyonderUser.userCode}}
                                        <br>
                                        <span
                                            [i18n]="'user-dashboard.blueyonder-user.form.help.line3'"></span>&nbsp;{{blueyonderUser.userCode}}
                                        <br>
                                        <span [i18n]="'user-dashboard.blueyonder-user.form.help.line4'"></span><br>
                                    </div>
                                </div>
                            </div>

                            <div class="form-buttons pull-left">
                                <button type="button" class="btn btn-primary btn-lg" (click)="location.back()">
                                    <span class="fa fa-close space-right-5"></span>
                                    <span [i18n]="'user-dashboard.blueyonder-user.form.buttons.cancel'"></span>
                                </button>
                            </div>
                            <div class="form-buttons pull-right">
                                <button type="submit" class="btn btn-primary btn-lg"
                                        [disabled]="blueyonderUserForm.invalid || blueyonderUserForm.pristine">
                                    <span class="fa fa-save space-right-5"></span>
                                    <span [i18n]="'user-dashboard.blueyonder-user.form.buttons.create'"></span>
                                </button>
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
